
<template>
  <v-form ref="form" class="mt-3 mx-3">
    
    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />

    <v-row>

      <v-col cols="12" sm="3">
        <v-autocomplete
          v-model="entry.previousHarvestId"
          v-bind="getObject('previousHarvestId')"
          label="Safra anterior"
          :items="extraData.accountContext.allHarvests"
          item-value="id"
          item-text="name"
          autocomplete="off"
          @input="selectPreviousHarvest"
        >
          <template v-slot:append-outer>
            <HarvestNew
              :inlineAddButton="true"
              @entry-created="harvestCreated"
              modelNameSingular="Safra"
            />
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="3">
        <v-autocomplete
          v-model="entry.harvestId"
          v-bind="getObject('harvestId')"
          label="Safra"
          :items="extraData.accountContext.allHarvests"
          item-value="id"
          item-text="name"
          autocomplete="off"
          :disabled="readOnly"
        >
          <template v-slot:append-outer>
            <HarvestNew
              :inlineAddButton="true"
              @entry-created="harvestCreated"
              modelNameSingular="Safra"
            />
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="6">
        <v-autocomplete
          v-model="entry.customerId"
          v-bind="getObject('customerId')"
          label="Cliente"
          :items="extraData.accountContext.allMyCustomers"
          item-value="id"
          item-text="name"
          autocomplete="off"
          :disabled="readOnly"
        >
          <!-- <template v-slot:append-outer>
            <HarvestNew
              :inlineAddButton="true"
              @entry-created="harvestCreated"
              modelNameSingular="Safra"
            />
          </template> -->
        </v-autocomplete>
      </v-col>


      <v-col cols="12" v-if="previousHarvest">
        <PreviousHarvestIndex
          :readOnly="readOnly"
          :isEdit="isEdit"
          :extraData="extraData"
          :items="previousHarvest"
          :itemGoal="entry"
        />
      </v-col>

      <v-col cols="12" v-if="entry.customerId && entry.harvestId && !previousHarvest">
        <ItemGoalIndex
          :readOnly="readOnly"
          :isEdit="isEdit"
          :extraData="extraData"
          :itemGoal="entry"
        />
      </v-col>

      

      <!-- <v-col cols="12" sm="12" md="6">
        <MaskedTextField
          v-bind="getObject('quantity')"
          :inputData.sync="entry.value"
          mask-type="currency_10d"
          label="Quantidade"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col> -->

      <!-- <v-col cols="12" sm="12" md="6">
        <MaskedTextField
          v-bind="getObject('commissionPercent')"
          :inputData.sync="entry.commissionPercent"
          mask-type="13v2"
          label="Percentual de comissão"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col> -->

    </v-row>
  </v-form>
</template>

<script>
import MaskedTextField from "@shared_components/masked_text_field.vue";
import gql from 'graphql-tag';
import BaseUtil from "@shared_components/base_util.vue";
import HarvestNew from "@models/harvests/new.vue";
import ItemGoalIndex from './item_goals/index.vue';
import PreviousHarvestIndex from './item_goals/previous_harvest_index.vue';
// import NewItemSelect from " /new_item_select.vue"

export default {
  data() {
    return {
      entryAttributes: {},
      purchaseItemsList: [],
      purchaseItemsListLoading: false,
      itemsSearch: "",
      packagingsListLoading: false,
      packagingsList: [],
      packagingsListKey: 0,
      pageLoading: false,
      previousHarvest: null,
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    MaskedTextField: MaskedTextField,
    HarvestNew: HarvestNew,  
    BaseUtil: BaseUtil,
    ItemGoalIndex: ItemGoalIndex,
    PreviousHarvestIndex: PreviousHarvestIndex,
    // NewItemSelect: NewItemSelect,
  },
  created() {
    this.entryAttributes = this.setupEntryAttributes(this.entry);
    // console.log("extra goal form", this.extraData);
    // this.extraData.goal = this.entry;
    
    console.log("goal form", this.entry);
    // if(!this.entry.itemGoals){
    //   this.entry.itemGoals=[];
    // }
  },
  mounted() {
    // if (this.entry.unitId) {
    //   this.getPackagingsForUnit(false);
    // }
  },
  watch: {
    itemsSearch: function(newSearch, oldSearch) {
      // console.log(newSearch, newSearch, oldSearch, oldSearch)
      if (this.itemsSearch && this.itemsSearch.length > 0) {
        if ((!this.entry.item || this.entry.item.name != this.itemsSearch) && newSearch.length >= 3) {
          if(this.timer){
            clearTimeout(this.timer);
          }
          this.timer = setTimeout( ()=> {
            // console.log(newSearch, newSearch);
            this.getPurchaseItems();
          }, 1000);
        }
      }
    },
  },
  methods: {
    selectPreviousHarvest: function(){
      // this.editableEntry = this.entry;
      console.log("entry", this.entry);
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_SALE_PREVIOUS_HARVEST_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            harvestId: this.entry.harvestId,
            previousHarvestId: this.entry.previousHarvestId,
            customerId: this.entry.customerId,
          }
        })
        .then(response => {
          this.previousHarvest = response.data.accountContext.previousHarvest;
          console.log("resp", response.data.accountContext.previousHarvest);
          // console.log("edit entry", this.editableEntry.itemGoals);
          // this.extraData = response.data;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    harvestCreated: function(harvest) {
      if (harvest) {
        this.extraData.accountContext.allHarvests.unshift(harvest);
        this.entry.harvestId = harvest.id;
        this.entry.harvest = harvest;
      }
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      // this.$refs.form.resetValidation();
    },
  }
};

const LOAD_SALE_PREVIOUS_HARVEST_QUERY = gql `
  query($customerId: ID!, $previousHarvestId: ID!, $harvestId: ID!){
    accountContext{
      goal {
        id
        validations
      }
      previousHarvest(customerId: $customerId, previousHarvestId: $previousHarvestId, harvestId: $harvestId){
        itemId
        goalTotalPrice
        previousQuantity
        previousSalePrice
        volume
        item{
          id
          name
          brand{
            id
            name
          }
          unit{
            id
            name
          }
        }
        itemGoals{
          totalPrice
          price
          quantity
          packagingId
          packaging{
            name
            size
          }
        }
      }
      allHarvests{
        name
        id
      }
      allMyCustomers{
        id
        name
      }
    }
  }
`;
</script>

<style scoped>
</style>


